import { motion } from "framer-motion";

interface MealImageGalleryProps {
  mainImage: string;
  thumbnails: string[];
  name: string;
}

export const MealImageGallery = ({ mainImage, thumbnails, name }: MealImageGalleryProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-4"
    >
      <img
        src={mainImage}
        alt={name}
        className="w-full h-[300px] object-cover rounded-lg shadow-lg"
      />
      <div className="grid grid-cols-3 gap-4">
        {thumbnails.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`${name} thumbnail ${index + 1}`}
            className="w-full h-24 object-cover rounded-md cursor-pointer hover:opacity-80 transition-opacity"
          />
        ))}
      </div>
    </motion.div>
  );
};